import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    messageError,
    status200,
    status400,
    messageToast,
    typeError
} from '../../utils/define';
import { Post } from '../../utils/httpProvider';
import { AUTH_API } from '../../utils/apiUrl.js';

const ForgotPassword = () => {
    const [t] = useTranslation();
    const history = useHistory();

    const addMutation = useMutation((value) =>
        Post(AUTH_API.FORGOT_PASSWORD, null, value, false, true)
    );

    const handlePost = async (values, actions) => {
        var model = {...values};
        addMutation.mutate(model, {
            onSuccess: async (respone) => {
                try {
                    if (respone.status === status200) {
                        history.push(URI_INTERNAL.RECOVER_PASSWORD_PATH);
                    }
                    if (respone.status === status400) {
                        const result = await respone.json();
                        if (result.type) {
                            if (result.type === typeError.UserName || result.type === typeError.Email) {
                                actions.setErrors({
                                    username: result.errors
                                        ? result.errors.content[0]
                                        : ''
                                });
                            }
                            if (result.type === typeError.Code) {
                                toast.error(result.errors.content[0]);
                                // history.push(
                                //     URI_INTERNAL.RECOVER_PASSWORD_PATH
                                // );
                            }
                        }
                    }
                } catch (error) {
                    toast.error(messageToast.messageToastTryCatch);
                }
            },
            onError: (error) => {
                console.log(error);
                toast.error(messageToast.messageToastTryCatch);
            }
        });
    };

    document.getElementById('root').classList = 'hold-transition login-page';

    const schema = yup.object().shape({
        username: yup
            .string()
            .trim()
            .required(messageError.emptyMessage)
            .matches(/^\d{12}$/, 'Tên đăng nhập phải là căn cước công dân gồm đúng 12 chữ số'),
    });
    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <b>Bệnh viện TWQĐ 108</b>
                        {/* <span>LTE</span> */}
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">
                        {/* {t('recover.forgotYourPassword')} */}
                        Bạn quên mật khẩu? Chúng tôi sẽ giúp bạn lấy lại mật
                        khẩu
                    </p>
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values, actions) =>
                            handlePost(values, actions)
                        }
                        initialValues={{
                            username: ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="input-group mb-3">
                                    {/* <input
                                        // ref={setEmailInputRef}
                                        type="email"
                                        className="form-control"
                                        placeholder="Email"
                                        value={values.email}
                                        onChange={handleChange}
                                        isInvalid={
                                            !!errors.email}
                                    /> */}
                                    <Form.Control
                                        placeholder="Username / Căn cước công dân"
                                        type="text"
                                        name="username"
                                        value={values.username}
                                        onChange={handleChange}
                                        isInvalid={!!errors.username}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-envelope" />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'block',
                                        color: '#dc3545'
                                    }}
                                >
                                    {errors.username}
                                </div>
                                {/* <Form.Control.Feedback type="invalid">
                                    {errors.username}
                                </Form.Control.Feedback> */}
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block"
                                        >
                                            Gửi
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                    {/* <p className="mt-3 mb-1">
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={() => history.goBack()}
                        >
                            Đăng nhập
                        </button>
                    </p> */}
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
